import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/MainGermany.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AIOptimizedSchema.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/CallToAction.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/EnergySolutionOverview.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/KnownFromStrip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ProductsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/SellingPropisition.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/StepsSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
